import { ModeTemplate } from "@/models/Mode";
import { translate } from "@/utils/translation";
import { Component, Prop, Vue } from "vue-property-decorator";

declare const window: any;
@Component
  export default class ModeTypeSelect extends Vue {

    @Prop({default: []}) private modes!: ModeTemplate[];
    @Prop({default: []}) private availableTypes!: string[];
    @Prop({default: []}) private selectedTypes!: string[];
    @Prop({default: 0}) private selectedModeIndex!: number;

    public store = this.$store.direct;
    
    private onModeClick(index: number) {
        this.$emit('onModeChange', index);
    }

    public get switcherPosition() {
        return this.selectedModeIndex === 0 ? 'left' : 'right';
    }

    public getIcon(index: number) {
        if(this.modes.length > 0) {
            const name = this.modes[index].IsHeating ? "flames" : "snow"
            const icon = `svguse:${process.env.VUE_APP_MODE_ICONS_PATH}#${name}`;
            return this.selectedModeIndex === index ? icon : `${icon}_inactive`;
        }
    }

    public onTypeSelect(type: string) {
        this.store.commit.selectorStateModule.TOGGLE_SELECTED_TYPE(type);
    }

    public isSelected(type: string) {
        return this.selectedTypes.includes(type);
    }

    private Translate(text: string): string {
        return translate(text);
      }
  }